export default __webpack_public_path__ + "6554624caa53ebc4bd760ff15f635bcb.bundle.svg";